@if (showAlert) {
  <app-alert-message [response]="messageInfo" (onClose)="onClose()"></app-alert-message>
}
<router-outlet></router-outlet>

